


export enum BreakpointsEnum {
	main = 1250
}